import styles from './image-preview-grid.module.css';

interface PastedImage {
    id: string;
    file: File;
    previewUrl: string;
}

interface UploadedImage {
    id: string;
    url: string;
}

interface Props {
    pastedImages: PastedImage[];
    uploadedImages: UploadedImage[];
    onRemovePasted: (id: string) => void;
    onRemoveUploaded: (id: string) => void;
}

export function ImagePreviewGrid(props: Props) {
    return (
        <div className={styles['image-preview-container']}>
            {props.pastedImages.map((img) => (
                <div key={img.id} className={styles['image-preview']}>
                    <img
                        src={img.previewUrl}
                        alt='Pasted image'
                        className={styles['preview-image']}
                    />
                    <div className={styles['image-type-badge']}>Pasted</div>
                    <button
                        onClick={() => props.onRemovePasted(img.id)}
                        type='button'
                        className={styles['remove-image-btn']}
                    >
                        ×
                    </button>
                </div>
            ))}
            {props.uploadedImages.map((img) => (
                <div key={img.id} className={styles['image-preview']}>
                    <img src={img.url} alt='Uploaded image' className={styles['preview-image']} />
                    <div className={styles['image-type-badge']}>Uploaded</div>
                    <button
                        onClick={() => props.onRemoveUploaded(img.id)}
                        type='button'
                        className={styles['remove-image-btn']}
                    >
                        ×
                    </button>
                </div>
            ))}
        </div>
    );
}
